/**
 * Utility to auto-detect if a CSV file is encoded in UTF-8 or ISO-8859-1 (Windows-1252).
 * This prevents special characters (e.g. René, Müller, Zoë) from being corrupted
 * when importing files exported from Excel on Windows systems.
 */
export function detectCsvEncoding(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = function (e) {
      const bytes = new Uint8Array(e.target.result);
      const isUtf = checkUtf8(bytes);
      resolve(isUtf ? 'UTF-8' : 'ISO-8859-1');
    };
    reader.onerror = function () {
      resolve('UTF-8'); // Fallback
    };
    // Read the first 50KB of the file (plenty for checking encoding)
    const slice = file.slice(0, 50 * 1024);
    reader.readAsArrayBuffer(slice);
  });
}

function checkUtf8(bytes) {
  let i = 0;
  const len = bytes.length;
  while (i < len) {
    const byte = bytes[i];
    if (byte <= 0x7F) {
      i++;
    } else if (byte >= 0xC2 && byte <= 0xDF) {
      if (i + 1 >= len) return false;
      if ((bytes[i + 1] & 0xC0) !== 0x80) return false;
      i += 2;
    } else if (byte >= 0xE0 && byte <= 0xEF) {
      if (i + 2 >= len) return false;
      if ((bytes[i + 1] & 0xC0) !== 0x80) return false;
      if ((bytes[i + 2] & 0xC0) !== 0x80) return false;
      i += 3;
    } else if (byte >= 0xF0 && byte <= 0xF4) {
      if (i + 3 >= len) return false;
      if ((bytes[i + 1] & 0xC0) !== 0x80) return false;
      if ((bytes[i + 2] & 0xC0) !== 0x80) return false;
      if ((bytes[i + 3] & 0xC0) !== 0x80) return false;
      i += 4;
    } else {
      return false;
    }
  }
  return true;
}
